/**
 * Header Module - Handles header interactions and scroll behavior
 */
import hasScrolled from "./utils/hasScrolled";

export class HeaderModule {
	constructor() {
		this.didScroll = false;
		this.lastScrollTop = 0;
		this.delta = 5;
		this.navbarHeight = 0;
		this.init();
	}

	updateHeaderHeightVar() {
		const headerWrapper = document.querySelector(".header-wrapper");
		document.documentElement.style.setProperty("--header-height", headerWrapper.offsetHeight + "px");
	}

	handleMenuToggle() {
		document.querySelectorAll(".menu-button > a").forEach((btn) => {
			btn.addEventListener("click", (e) => {
				e.preventDefault();
				this.updateHeaderHeightVar();
				const nav = btn.closest(".header-wrapper").querySelector("nav");
				btn.classList.toggle("active");
				nav.classList.toggle("active");
				document.body.classList.toggle("menu-open");
			});
		});
	}

	closeMenu() {
		document.querySelector(".header-wrapper nav")?.classList.remove("active");
		document.querySelector(".menu-button > a")?.classList.remove("active");
		document.body.classList.remove("menu-open");
	}

	handleNavLinkClick() {
		document.querySelectorAll("nav a").forEach((link) => {
			link.addEventListener("click", () => this.closeMenu());
		});
	}

	initScrollBehavior() {
		this.navbarHeight = document.querySelector("header")?.offsetHeight ?? 0;

		window.addEventListener("scroll", () => {
			this.didScroll = true;
		});

		setInterval(() => {
			if (this.didScroll) {
				hasScrolled();
				this.didScroll = false;
			}
		}, 250);
	}

	calcVars() {
		const header = document.querySelector("header");
		const socialHead = document.querySelector(".social-head");
		const height = (header?.offsetHeight ?? 0) + (socialHead?.offsetHeight ?? 0);
		document.documentElement.style.setProperty("--header-height", `${height}px`);
	}

	init() {
		this.calcVars();
		this.handleMenuToggle();
		this.handleNavLinkClick();
		this.initScrollBehavior();
	}
}
